export const integrationGroup = {
  'E-commerce': [
    {
      id: 'SHOPIFY_V2',
      copy: 'View and manage your customers Shopify orders right from Groove.',
      iconCls: 'shopify',
    },
    {
      id: 'RECHARGE',
      copy: `Manage your Recharge customers subscriptions from the ${app.t(
        'mailbox'
      )}.`,
      iconCls: 'recharge',
    },
    {
      id: 'SLACK',
      copy: 'Get notified directly in Slack for events in Groove.',
    },
    {
      id: 'MAILCHIMP',
      copy: `Manage and organize your customers subscriptions from the ${app.t(
        'mailbox'
      )}.`,
    },
  ],
  Software: [
    {
      id: 'STRIPE',
      copy: `Manage your Stripe customers subscriptions right from the ${app.t(
        'mailbox'
      )}.`,
      iconCls: 'stripe',
    },
    {
      id: 'TRELLO',
      copy: 'Add cards and get updates for your Trello account in Groove.',
    },
    {
      id: 'JIRA_CLOUD',
      copy: `Create, view and update Jira tasks straight from your ${app.t(
        'mailbox'
      )}.`,
      iconCls: 'md-icon',
    },
    {
      id: 'SLACK',
      copy: 'Get notified directly in Slack for events in Groove.',
    },
  ],
  Other: [
    {
      id: 'SLACK',
      copy: 'Get notified directly in Slack for events in Groove.',
    },
    {
      id: 'TRELLO',
      copy: 'Add cards and get updates for your Trello account in Groove.',
    },
    {
      id: 'MAILCHIMP',
      copy: `Manage and organize your customers subscriptions from the ${app.t(
        'mailbox'
      )}.`,
    },
    {
      id: 'ZAPIER',
      copy: `Connect Groove to 1000's of apps using Zapier!`,
      iconCls: 'zapier',
    },
  ],
}
